
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as n from "@/types/notifications";
import StackTrace from "@/components/Notifications/Types/Util/StackTrace.vue";

@Component({
  components: {
    StackTrace
  }
})
export default class InternalServerErrorErrorDetails extends Vue {
  @Prop()
  value!: n.InternalServerErrorDetails;
}
